import { isNil } from 'lodash';
import { InvestorsData } from 'utils/entities';
import { formatGainAfterRenewal, formatInvestorsYield } from 'utils/investors';


export const getInvestorMetrics = (
  investorsData: InvestorsData,
  gainAfterRenewal: number,
  noDataText: string
) => ({
  yieldValue: investorsData && investorsData.yield
    ? `${formatInvestorsYield(investorsData.yield)}%`
    : noDataText,
  gainPercentageAfterRenewal: !isNil(gainAfterRenewal)
    ? formatGainAfterRenewal(gainAfterRenewal)
    : noDataText,
});

export const getPricePerSqm = (price: number, area: number) => (
  area > 0 && !isNil(price) ? Math.round(price / area) : null
);
